import { MATRIX_EMPLOYEE_COLUMN_WIDTH } from '../reportStyles';

import type { ReactNode } from 'react';

interface MatrixLevelCellProps {
    children: ReactNode;
    dataTestId?: string;
}

/** One employee's cell in a group or competency row: fixed width, centered content. Shared by
 * `MatrixGroupRow` (a `CustomPill`) and `MatrixCompetencyRow` (a `ProficiencyIcon`) so the column
 * width and centering live in one place instead of being duplicated across both rows. */
export const MatrixLevelCell = ({ children, dataTestId }: MatrixLevelCellProps) => (
    <div
        className={`${MATRIX_EMPLOYEE_COLUMN_WIDTH} flex shrink-0 items-center justify-center`}
        data-testid={dataTestId}
    >
        {children}
    </div>
);
